import { getTimelineSteps } from "@/views/handbook/timelineSteps/services";
import { timelineStepConditionsAPI } from "@/views/handbook/timlineStepConditions/api";
import { getStepActivities } from "@/views/handbook/stepActivity/services";
import instance from "@/services/api";

export async function getStepIncludeConditions() {
  try {
    const res = await instance()
      .get("/timeline/handbook/step_include_cond/read/")
      .then((r) => r?.data);
    return res?.data;
  } catch (e) {}
}

async function getAllStepConditions() {
  try {
    const res = await timelineStepConditionsAPI.getList();
    return res?.data || [];
  } catch (e) {
    return [];
  }
}

export async function loadStepLibraryPreviewData(excludeStepIds = []) {
  const [steps, conditions, activities, includeConditions] = await Promise.all([
    getTimelineSteps(),
    getAllStepConditions(),
    getStepActivities(),
    getStepIncludeConditions(),
  ]);

  const exclude = new Set(excludeStepIds);
  const availableSteps = (steps || []).filter((step) => !exclude.has(step.step_id));

  const activeOnly = (rows) => (rows || []).filter((row) => row.is_active !== false);

  return {
    steps: availableSteps,
    conditionsByStep: groupByStepId(activeOnly(conditions)),
    activitiesByStep: groupByStepId(activeOnly(activities)),
    includeByStep: groupByStepId(activeOnly(includeConditions)),
  };
}

function groupByStepId(rows) {
  return (rows || []).reduce((acc, row) => {
    const stepId = row.step_id;
    if (!stepId) return acc;
    if (!acc[stepId]) acc[stepId] = [];
    acc[stepId].push(row);
    return acc;
  }, {});
}
